import { Theme } from "./Theme";

export const lightTheme: Theme = {
  colors: {
    neutral: {
      background: "#f5f5f7",
      text: "#1d1d1f",
      border: "#eaeaea",
      secondaryText: "#5e5e5e",
      imageFallbackBackground: "#eaeaea",
      buttonBackground: "#eaeaea",
      dropdownSelected: "#0062ff",
      tabColor: "#5e5e5e",
      selectedTabColor: "#1d1d1f",
    },
  },
};
